// extracted by mini-css-extract-plugin
export default {"modal":"CD4UF","modalContent":"U3ihk","modalWrapper":"HKlN3","modalButtons":"k9EPM","projectUpdatesWrapper":"RKJNg"};